import { Button, ButtonGroup } from '@zillow/constellation-10';
import { TourWizardSteps } from '../../../../constants/TourCalendar';
import { wizardContainerStyles, wizardFooterButtonStyles } from '../../styles';

type TourAvailabilityCalendarFooterProps = {
  isNextDisabled: boolean;
  isNextLoading: boolean;
  onClickBack: () => void;
  onClickNext: () => void;
  step: TourWizardSteps;
  hasEnabledTouring: boolean;
};

const TourAvailabilityCalendarFooter = ({
  isNextDisabled,
  isNextLoading,
  onClickBack,
  onClickNext,
  step,
  hasEnabledTouring,
}: TourAvailabilityCalendarFooterProps) => {
  const isCalendarStep = step === TourWizardSteps.CALENDAR;
  const hasBackButton = (isCalendarStep || step === TourWizardSteps.TIME_ZONE) && !hasEnabledTouring;

  return (
    <ButtonGroup
      aria-label="Tour availability navigation"
      fluid={{ base: true, lg: false }}
      css={{ ...wizardContainerStyles, justifyContent: hasBackButton ? 'space-between' : 'flex-end' }}
    >
      {hasBackButton && (
        <Button
          tone="neutral"
          emphasis="outlined"
          css={wizardFooterButtonStyles}
          onClick={onClickBack}
          data-testid="TourCalendarFooter-BackBtn"
        >
          Back
        </Button>
      )}
      <Button
        tone="brand"
        emphasis="filled"
        loading={isNextLoading}
        disabled={isNextDisabled}
        css={wizardFooterButtonStyles}
        onClick={onClickNext}
        data-testid="TourCalendarFooter-NextBtn"
      >
        {isCalendarStep ? 'Close' : 'Next'}
      </Button>
    </ButtonGroup>
  );
};

export default TourAvailabilityCalendarFooter;
